import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import { connect } from "react-redux";
import jwtDecode from "jwt-decode";
import { TextField, Paper, Button, CircularProgress } from "@material-ui/core";
import { Typography } from "@material-ui/core";

import { url } from "../../../config/config";
import logo from "../../../Assets/Images/logo.png";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";

const useStyles = (theme) => ({
  signRoot: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    paddingTop: 50,
    paddingBottom: 50,
  },
  title: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  paper: {
    padding: 30,
  },
  nameinputStyle: {
    outline: "none",
    width: "49%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  errorStyle: {
    color: "red",
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 20,
  },
});

class FeedBack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: "",
        message: "",
        createdAt: new Date().toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
      messageError: "",
      errorMessage: "",
      error: true,
      success: "",
    };
  }

  componentDidMount() {
    this.decodeToken(this.props.userToken);
  }

  decodeToken = (token) => {
    try {
      let decode = jwtDecode(token);
      this.setState({
        data: {
          email: decode.email,
        },
      });
    } catch (error) {
      // console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = (errorMessage) => {
    let messageError = "";

    if (this.state.data.message.length < 3) {
      messageError = "Message must be minimum of 3 characters";
    }

    if (messageError || errorMessage) {
      this.setState({
        messageError,
        errorMessage,
      });
      return true;
    } else {
      this.setState({
        messageError: "",
        errorMessage: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    this.setState({ error: errorStatus });
    if (errorStatus === false) {
      const response = await Axios.post(
        `${url}/api/feedbacks`,
        this.state.data
      );
      if (response.data.error) {
        this.checkError(response.data.error);
      } else {
        if (response.data.success && errorStatus === false) {
          this.setState({ success: response.data.success });
          this.props.history.push("/");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div className={classes.signRoot}>
          <Paper className={classes.paper}>
            <form onSubmit={this.handleSubmit}>
              <Typography variant="h5" className={classes.title}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={logo}
                    alt="logo"
                    style={{ width: 40, height: 30 }}
                  />
                  Digi-Book
                </div>
                <div>
                  <strong>FeedBack</strong>
                </div>
              </Typography>

              <TextField
                name="email"
                type="email"
                label="Email"
                fullWidth
                required
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                error={this.state.emailError ? true : false}
                helperText={this.state.emailError}
                InputProps={{
                  classes: {
                    root: classes.inputRoot,
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.email}
                onChange={this.handleChange}
              />

              <TextField
                name="message"
                type="string"
                label="Message"
                fullWidth
                required
                multiline
                rows={4}
                rowsMax={8}
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                error={this.state.messageError ? true : false}
                helperText={this.state.messageError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.message}
                onChange={this.handleChange}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button type="submit" className={classes.buttonStyle}>
                  Submit
                </Button>
              </div>

              {!this.state.success && this.state.error === false && (
                <div
                  style={{
                    fontSize: 25,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please Wait for a moment, Submiting feedback Redirected to
                  homepage
                  <CircularProgress />
                </div>
              )}
              <br />
            </form>
          </Paper>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(FeedBack)));
